import { Chart, registerables } from "chart.js";
import React, { useEffect, useRef } from "react";

Chart.register(...registerables);

interface DatasetProps {
  label: string;
  data: number[];
  backgroundColor?: string | string[];
  borderColor?: string | string[];
  borderWidth?: number;
  fill?: boolean;
}

interface LineChartProps {
  labels: string[];
  datasets: DatasetProps[];
}

const LineChart: React.FC<LineChartProps> = ({ datasets, labels }) => {
  const chartRef = useRef<HTMLCanvasElement>(null);
  const chartInstance = useRef<Chart<"line", number[], string> | null>(null);

  useEffect(() => {
    if (chartRef.current) {
      if (chartInstance.current) {
        chartInstance.current.destroy();
      }
      const ctx = chartRef.current.getContext("2d")!;

      chartInstance.current = new Chart(ctx, {
        type: "line",
        data: {
          labels: labels,
          datasets: datasets.map((dataset) => ({
            label: dataset.label,
            data: dataset.data,
            backgroundColor: dataset.backgroundColor,
            borderColor: dataset.borderColor,
            borderWidth: dataset.borderWidth,
            fill: dataset.fill ?? false,
            tension: 0.3,
          })),
        },
        options: {
          scales: {
            y: {
              beginAtZero: true,
            },
          },
          responsive: true,
          plugins: {
            legend: {
              display: false,
              // position: "top",
              // align: "end",
              // labels: {
              //   usePointStyle: true,
              //   pointStyle: "circle",
              //   boxWidth: 10,
              //   boxHeight: 10,
              //   padding: 20,
              //   font: {
              //     size: 18,
              //     weight: 500,
              //   },
              //   color: "#1D2129",
              // },
            },
            tooltip: {
              mode: "index",
              intersect: false,
            },
          },
        },
      });
    }
  }, [datasets, labels]);

  return <canvas ref={chartRef} width="400" height="100"></canvas>;
};

export default LineChart;
